import { z } from "zod";
import { apiListSchema } from "./list";

//? DTO
export const ReservationClientDtoSchema = z.object({
  ReservationId: z.number(),
  ClientId: z.number(),
  FlightNumber: z.string().nullish(),
  NeedsBike: z.boolean().nullish(),
  PickupAddress: z.string().nullish(),
  Tags: z.string().nullish(),
});
export type ReservationClientDto = z.infer<typeof ReservationClientDtoSchema>;

export const reservationClientDtoListSchema = apiListSchema(
  ReservationClientDtoSchema
);
//? Model

const ReservationClientTagsSchema = z
  .object({
    arrivalDetails: z.string().nullish(),
    departureDetails: z.string().nullish(),
  })
  .nullish();

type ReservationClientTags = z.infer<typeof ReservationClientTagsSchema>;
export const ReservationClientSchema = z.object({
  reservationId: z.number(),
  flightNumber: z.string().nullish(),
  needsBike: z.boolean().nullish(),
  pickupAddress: z.string().nullish(),
  clientId: z.number(),
  arrivalDetails: z.string().nullish(),
  departureDetails: z.string().nullish(),
});

export type ReservationClient = z.infer<typeof ReservationClientSchema>;

//? Mappers

export function createReservationClientToDto(
  client: ReservationClient
): ReservationClientDto {
  const tags: ReservationClientTags = {
    arrivalDetails: client.arrivalDetails,
    departureDetails: client.departureDetails,
  };
  return {
    FlightNumber: client.flightNumber,
    NeedsBike: client.needsBike,
    ClientId: client.clientId,
    PickupAddress: client.pickupAddress,
    ReservationId: client.reservationId,
    Tags: JSON.stringify(tags),
  };
}

export function reservationClientFromDto(
  dto: ReservationClientDto
): ReservationClient {
  const tags: ReservationClientTags = dto.Tags
    ? ReservationClientTagsSchema.parse(JSON.parse(dto.Tags))
    : undefined;
  return {
    clientId: dto.ClientId,
    reservationId: dto.ReservationId,
    flightNumber: dto.FlightNumber,
    needsBike: dto.NeedsBike,
    pickupAddress: dto.PickupAddress,
    arrivalDetails: tags?.arrivalDetails,
    departureDetails: tags?.departureDetails,
  };
}

export function reservationClientToDto(
  dto: ReservationClient
): ReservationClientDto {
  return {
    ...createReservationClientToDto(dto),
  };
}
